import { createSelector } from 'reselect'
import { getSelectedDay } from '../booking/selectors'
import { parse } from 'date-fns'

const getAvailabilityState = state => state.availability

export const getShowedMonth = createSelector(
  getAvailabilityState,
  availabilityState => availabilityState.month
)

export const getShowedYear = createSelector(
  getAvailabilityState,
  availabilityState => availabilityState.year
)

export const getAvailabilitiesFilter = createSelector(
  getAvailabilityState,
  availabilityState => availabilityState.filter
)

export const isAvailabilitiesLoading = createSelector(
  getAvailabilityState,
  availabilityState => availabilityState.isLoading
)

const applyFilter = (filter, day) => {
  if (filter === 'ALL') return day
  return {
    ...day,
    orari: day.orari.filter(orario => orario.tipo === filter)
  }
}

const parseRawDayToCalendarDay = day => {
  let state = 'busy'
  if (day.tipo === 'FESTIVO') {
    state = 'holiday'
  }
  if (day.orari.some(orario => orario.disponibile)) {
    state = 'free'
  }
  return {
    day: parse(day.data).getDate(),
    state: state
  }
}

export const getDays = createSelector(
  getAvailabilityState,
  getAvailabilitiesFilter,
  (availabilityState, filter) => {
    return availabilityState.days
      .map(applyFilter.bind(null, filter))
      .map(parseRawDayToCalendarDay)
  }
)

export const getSelectedDayAvailabilities = createSelector(
  getAvailabilityState,
  getSelectedDay,
  (availabilityState, selectedDay) => {
    if (!selectedDay) return null
    return availabilityState.days.find(
      day => parse(day.data).getDate() === selectedDay.getDate()
    )
  }
)

export const hasAvailabilityLoadingErrors = createSelector(
  getAvailabilityState,
  availabilityState => availabilityState.loadingError !== null
)
